// react
import React, { Suspense } from "react";

export const SuspenseLayout = ({ element }: any) => (
  <Suspense fallback={<>Loading...</>}>{element}</Suspense>
);
